import * as React from "react";
import { forwardRef } from "react";
const SvgWhatsUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 25 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M21.5714 1.48663H3.28571C2.02335 1.48663 1 2.50998 1 3.77235V28.9152C1 30.1776 2.02335 31.2009 3.28571 31.2009H21.5714C22.8338 31.2009 23.8571 30.1776 23.8571 28.9152V3.77235C23.8571 2.50998 22.8338 1.48663 21.5714 1.48663Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.4286 25.4866H13.8572",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M9.76148 12.2188L5.42859 18.5795V20.3438H17.8869V18.1074H8.3848V18.0284L12.3814 12.2188H9.76148Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M5.97028 7.34375V9.57999H15.4724V9.659L11.4758 15.4688H14.0956L18.4286 9.10792V7.34375H5.97028Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgWhatsUp);
export default ForwardRef;
